const SECCODE_REGEXP = /^\d{1,6}$/;

export function isValidSecurityCode(text = '') {
  return !!text && SECCODE_REGEXP.test(text);
}
